export const CANONICAL_MEDIA_STRATEGIES = ["inherit", "listing_override"] as const;
export type CanonicalMediaStrategy = (typeof CANONICAL_MEDIA_STRATEGIES)[number];

/** UI alias historically used in the workspace. Never persist this value. */
export const LEGACY_CUSTOM_MEDIA_STRATEGY = "custom";

export function isCanonicalMediaStrategy(value: string | null | undefined): value is CanonicalMediaStrategy {
  return value === "inherit" || value === "listing_override";
}

/**
 * Map any UI/service alias onto the DB check constraint
 * channel_listings_media_strategy_check: ('inherit','listing_override').
 */
export function toCanonicalMediaStrategy(value: string | null | undefined): CanonicalMediaStrategy | null {
  if (value == null || value === "") return "inherit";
  if (value === LEGACY_CUSTOM_MEDIA_STRATEGY) return "listing_override";
  if (isCanonicalMediaStrategy(value)) return value;
  return null;
}

export function mediaStrategyRequiresPrimaryAsset(strategy: CanonicalMediaStrategy): boolean {
  return strategy === "listing_override";
}

export function friendlyMediaStrategyError(raw: string | null | undefined): string | null {
  if (!raw) return null;
  if (/media_strategy_check|invalid media strategy|media_strategy/i.test(raw)) {
    return "Media strategy must be inherit (canonical gallery) or listing_override (chosen primary image). The chosen image is stored separately as listing primary media.";
  }
  return null;
}

export function mapCreateListingError(raw: string | null | undefined): string {
  return friendlyMediaStrategyError(raw) || raw?.trim() || "Failed to create draft listing.";
}
